import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = { class: "home-page" };
const _hoisted_2 = { class: "category-nav" };
const _hoisted_3 = { class: "latest-articles" };
const _hoisted_4 = {
    class: "home-sidebar",
    "aria-label": "站点侧栏"
};
const _hoisted_5 = { class: "widget" };
const _hoisted_6 = { class: "widget" };
const _hoisted_7 = { class: "category-distribution" };
const _hoisted_8 = { class: "widget" };
import { ref, onMounted } from 'vue';
import ArticleList from '@/components/article/ArticleList.vue';
import TagCloudPreview from '@/components/page/TagCloudPreview.vue';
import ArchivePreview from '@/components/page/ArchivePreview.vue';
import { getArticleList, getCategoryDistribution } from '@/api/article';
const siteTitle = 'Software defines the future';
const siteSubtitle = '记录技术成长，分享思考感悟';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Home',
    setup(__props) {
        /**
         * 首页
         * 展示博客介绍、最新文章、热门标签等信息
         */
        const articles = ref([]);
        const popularTags = ref([]);
        const categoryDistribution = ref([]);
        const getCategoryToneStyle = (count, list) => {
            const safeCount = Number.isFinite(count) ? count : 0;
            const maxCount = Math.max(...list.map((item) => item.count), 1);
            const ratio = Math.max(0, Math.min(safeCount / maxCount, 1));
            const startAlpha = 0.1 + ratio * 0.18;
            const endAlpha = 0.05 + ratio * 0.1;
            const borderAlpha = 0.18 + ratio * 0.24;
            return {
                background: `linear-gradient(120deg, rgba(154, 107, 58, ${startAlpha.toFixed(3)}), rgba(154, 107, 58, ${endAlpha.toFixed(3)}))`,
                borderColor: `rgba(154, 107, 58, ${borderAlpha.toFixed(3)})`
            };
        };
        // 页面加载获取文章列表
        onMounted(async () => {
            try {
                const result = await getArticleList({ page: 1, pageSize: 5 });
                articles.value = result.list;
                categoryDistribution.value = await getCategoryDistribution();
            }
            catch (error) {
                console.error('获取文章列表失败', error);
            }
        });
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createCommentVNode(" 博客标题区域 "),
                _createElementVNode("header", { class: "site-header" }, [
                    _createElementVNode("h1", { class: "site-title" }, _toDisplayString(siteTitle)),
                    _createElementVNode("p", { class: "site-subtitle" }, _toDisplayString(siteSubtitle))
                ]),
                _createCommentVNode(" 内容分类导航 "),
                _createElementVNode("nav", _hoisted_2, [
                    _createElementVNode("ul", null, [
                        _createElementVNode("li", null, [
                            _createVNode(_component_router_link, { to: "/article" }, {
                                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                        _createTextVNode("全部文章", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _createElementVNode("li", null, [
                            _createVNode(_component_router_link, { to: "/article?category=tech" }, {
                                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                        _createTextVNode("技术博客", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _createElementVNode("li", null, [
                            _createVNode(_component_router_link, { to: "/article?category=life" }, {
                                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                        _createTextVNode("生活随笔", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _createElementVNode("li", null, [
                            _createVNode(_component_router_link, { to: "/article?category=reading" }, {
                                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                        _createTextVNode("读书笔记", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _createElementVNode("li", null, [
                            _createVNode(_component_router_link, { to: "/projects" }, {
                                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                        _createTextVNode("项目展示", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            })
                        ])
                    ])
                ]),
                _createCommentVNode(" 最新文章列表 "),
                _createElementVNode("section", _hoisted_3, [
                    _cache[5] || (_cache[5] = _createElementVNode("h2", null, "最新文章", -1 /* CACHED */)),
                    _createVNode(ArticleList, { articles: articles.value }, null, 8 /* PROPS */, ["articles"])
                ]),
                _createCommentVNode(" 侧边信息（移动端排在正文之后，先读文章再浏览标签/归档） "),
                _createElementVNode("aside", _hoisted_4, [
                    _createCommentVNode(" 标签云 "),
                    _createElementVNode("div", _hoisted_5, [
                        _cache[6] || (_cache[6] = _createElementVNode("h3", null, "热门标签", -1 /* CACHED */)),
                        _createVNode(TagCloudPreview, { tags: popularTags.value }, null, 8 /* PROPS */, ["tags"])
                    ]),
                    _createCommentVNode(" 分类分布 "),
                    _createElementVNode("div", _hoisted_6, [
                        _cache[7] || (_cache[7] = _createElementVNode("h3", null, "分类分布", -1 /* CACHED */)),
                        _createElementVNode("div", _hoisted_7, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryDistribution.value, (item) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    class: "category-item",
                                    key: item.name,
                                    style: _normalizeStyle(getCategoryToneStyle(item.count, categoryDistribution.value))
                                }, [
                                    _createElementVNode("span", null, _toDisplayString(item.name), 1 /* TEXT */),
                                    _createElementVNode("strong", null, _toDisplayString(item.count), 1 /* TEXT */)
                                ], 4 /* STYLE */));
                            }), 128 /* KEYED_FRAGMENT */))
                        ])
                    ]),
                    _createCommentVNode(" 归档预览 "),
                    _createElementVNode("div", _hoisted_8, [
                        _cache[8] || (_cache[8] = _createElementVNode("h3", null, "文章归档", -1 /* CACHED */)),
                        _createVNode(ArchivePreview)
                    ])
                ])
            ]));
        };
    }
});
